import { flexCenter } from '@anm/styles/helpers';
import styled, { css } from 'styled-components';

import { ImageRatioContainer } from '../Wrapper';
import { VideoRatioDirections, VideoRatioItemWrapperProps, VideoRatioVariants } from '../types';

export const RatioContentWrapper = styled.div``;

const whiteRatioStyles = css`
  color: #fff;
  img {
    outline-color: #fff;
  }
`;
const greyRatioStyles = css`
  color: #919eaa;
  img {
    outline-color: #919eaa;
  }
`;

const variants: { [key in VideoRatioVariants]: ReturnType<typeof css> } = {
  black: css`
    ${greyRatioStyles};
    &:hover {
      color: #292a2b;
      img {
        outline-color: #292a2b;
      }
      > div {
        border-bottom-color: #292a2b;
      }
    }
  `,
  white: css`
    ${whiteRatioStyles};
    &:hover {
      ${greyRatioStyles};
    }
  `,
  gray: css`
    ${greyRatioStyles}
    &:hover {
      ${whiteRatioStyles};
    }
  `
};

const directions: { [key in VideoRatioDirections]: ReturnType<typeof css> } = {
  row: css`
    padding-right: 15px;
    border-bottom: 1px solid #cbdce5;
    ${RatioContentWrapper} {
      flex-direction: row;
      padding-bottom: 14px;

      margin: 14px 0 -1px 0;
      img {
        margin-right: 10px;
      }
    }
    &:last-of-type {
      padding-right: 0;
    }
  `,
  column: css`
    ${RatioContentWrapper} {
      flex-direction: column;
      ${ImageRatioContainer} {
        margin-bottom: 5px;
      }
    }
  `
};

const getHoverItemStyles = (activeColor?: string) => css`
  color: ${activeColor || 'var(--blue_100)'};
  img {
    outline-color: ${activeColor || 'var(--blue_100)'};
  }
  ${RatioContentWrapper} {
    border-bottom-color: ${activeColor || 'var(--blue_100)'};
  }
`;

const getActiveItemStyles = (activeColor?: string) => css`
  color: ${activeColor || 'var(--blue_100)'};
  img {
    outline-color: ${activeColor || 'var(--blue_100)'};
  }
`;

const VideoRatioItem = styled.li<VideoRatioItemWrapperProps>`
  ${RatioContentWrapper} {
    ${flexCenter};
    margin: 5px 25px 5px;
    cursor: pointer;
    user-select: none;
    white-space: nowrap;
    line-height: 28px;
    border-bottom-width: 1px;
    border-bottom-style: solid;
    border-bottom-color: ${({ isActive, activeRatioItemColor }) =>
      isActive ? activeRatioItemColor || 'var(--blue_100)' : 'transparent'};
    &:last-of-type {
      margin-right: 0;
    }
    img {
      outline-offset: -2px;
      outline-style: solid;
      outline-width: 2px;
    }
  }

  ${({ variant, direction }) => [...variants[variant], ...directions[direction]]};

  ${({ isActive, activeRatioItemColor }) => isActive && getActiveItemStyles(activeRatioItemColor)};

  &:hover {
    ${({ isActive, activeRatioItemColor }) => isActive && getHoverItemStyles(activeRatioItemColor)};
  }
`;

export default VideoRatioItem;
